import { mergeDeepRight } from 'ramda'
import { i18n } from '@/i18n'

import { VueComponentUpload as upload } from '@kvass/storage'
import onFileDrop from '@/components/vendors/kvass-file/onDrop'
import onError from '@/components/vendors/vue-elder-loader/onError'
import MediaOnDrop from '@/components/vendors/kvass-media/onDrop'

import { setup as FileSetup } from '@kvass/file'
import { setup as ButtonSetup } from 'vue-elder-button'
import { setup as LoaderSetup } from 'vue-elder-loader'
import { setup as MediaSetup } from '@kvass/media'
import { setup as RichTextSetup } from '@kvass/rich-text/index.js'
import { setup as StepperSetup } from 'vue-elder-stepper'

export default () => {
  ButtonSetup({
    type: 'button',
    labels: {
      loading: i18n.t('loading', { resource: undefined }) + '...',
      error: i18n.t('somethingWentWrong'),
      confirm: i18n.t('areYouSure'),
      success: i18n.t('completed'),
    },
  })

  LoaderSetup({
    messages: {
      loading: i18n.t('loading', { resource: undefined }) + '...',
      error: onError,
    },
  })

  MediaSetup({
    upload: (rawFile, onProgress, options) =>
      upload(
        rawFile,
        onProgress,
        mergeDeepRight(
          {
            compression: 'gallery',
            transform: v => ({ ...v, tags: [], description: null, hash: null }),
          },
          options,
        ),
      ),
    dropMessage: MediaOnDrop,
    labels: {
      image: i18n.tc('image', 1),
      select: i18n.t('select'),
      cancel: i18n.t('cancel'),
      save: i18n.t('save'),
      descriptionPlaceholder: i18n.t('mediaDescriptionPlaceholder'),
      selectMessage: i18n.t('mediaTypeDefaultMessage'),
      tagsPlaceholder: `${i18n.t('add')} ${i18n.tc('tag', 1).toLowerCase()}`,
      dragInstructions: i18n.t('focusPointDragInstructions'),
      focusPointTitle: i18n.t('focusPointTitle'),
      focusPointDescription: i18n.t('focusPointDescription'),
      resetFocusPoint: i18n.t('resetFocusPoint'),
    },
  })

  FileSetup({
    upload,
    dropMessage: onFileDrop,
  })

  RichTextSetup({
    labels: {
      primary: i18n.t('primaryColor'),
      secondary: i18n.t('secondaryColor'),
    },
  })

  StepperSetup({
    icons: {
      breadcrumb: ['fal', 'long-arrow-right'],
    },
  })
}
